<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        12.18
        <br />2015
      </span>
      <span class="tiel">美菜O2O将改变农业</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/97d857f257169aec658f5531cd28147c.jpg"
          width="640"
        />
      </p>
      <div class="tet-js">
        2015年12月17日，第二届世界互联网大会。美菜网创始人、CEO刘传军主持 “互联网创新与初创企业成长”论坛，并作为嘉宾参与“中小企业O2O创新的机遇与挑战”讨论。关于讨论中的一些问题，刘传军认为：
        <br />
        <br />

        <b>为什么现在是O2O的一个关键时刻？现在的环境是什么样的？</b>美菜的发展和整个大的经济形势与互联网的发展是分不开的，早在2010年，我就想做农产品电商，经过调研发现中小餐厅有强烈需求，但问题在于没有方法达成交易。没有互联网，没有WIFI, 没有智能手机。2012年底我又去调研餐厅，时机还是不成熟 。到了2013年底，发现中小餐厅中大概40-50%有了智能手机，4G、无线网、微信的出现，使得时机来了，具备了条件。所以说：移动互联网对于美菜，对于整个O2O行业都起到了积极的推动作用。
        <br />
        <br />

        <b>O2O行业有哪些独特的挑战与问题？</b>1农村信息化程度低：我们做农产品，做美菜的业务，连接的一端是农民。但目前，农村的互联网化、信息化程度很低，美菜做的业务是连接地头到餐桌，但是地头端也就是农民互联网化不高，大部分业务还是需要线下沟通处理。2线上支付能力弱：中国中小餐饮里面，移动支付能力很弱，70—80%还是线下支付。3商品非标准化：我们是自营电商平台，自做采购、仓储、物流、生鲜产品的非标准化给整个运营带来了很大困难。美菜也在加快推进生鲜产品的标准化。4运营效率还需大幅提升：美菜的商品本身是生鲜，是有生命的，很娇气。若想在很短的时间内完成，从地头到餐桌，挑战很大。所以，整个运营体系的效率提升很重要，但随着互联网的发展及生鲜农产品标准化，很多挑战都会解决。
        <br />
        <br />

        <b>如何扩大企业规模？如何解决客户的留存及回头率？</b>1服务：保持公司的高速成长及市场占有率，核心就是能否将服务持续优化提升，只有将服务做到极致才能保证客户的留存。2执行力：美菜业务发展有很多模块，涉及地推、技术、物流等等，要想保证企业的健康发展，并为客户持续提供优质服务，就需要有极强执行力的团队。
        <br />
        <br />

        <b>未来O2O趋势？</b>近几年的趋势，包括国家相关政策的扶持，整个互联网向农村、农业下沉。我们做的事是农产品流通环节。未来在农产品产业化方面，将会有很多资本投入，会刺激农业产业化的发展。
        <br />
        <br />美菜简介：2014年6月6日，北京云杉信息技术有限公司旗下的美菜网成立。作为中国领先的农产品移动电商平台，美菜网一直致力于用前卫的理念和先进的科技颠覆中国农业市场。致力于帮助全国近千万家餐厅做采购。致力于打通从地头到终端的农产品供应链，缩短农产品流通环节，降低商户供应链成本，减少供应链人力。全流程精细化管控菜品从田间到餐桌的每一处细节。同时可提高农民收入，减少压货风险，降低农民损失，促进资源合理分配。预计在2016年，美菜业务将覆盖全国100个城市。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
